import { render, staticRenderFns } from "./AppBottomNavigation.vue?vue&type=template&id=5f1ff489"
import script from "./AppBottomNavigation.vue?vue&type=script&lang=js"
export * from "./AppBottomNavigation.vue?vue&type=script&lang=js"
import style0 from "./AppBottomNavigation.vue?vue&type=style&index=0&id=5f1ff489&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFooter } from 'vuetify/lib/components/VFooter';
installComponents(component, {VBtn,VFooter})


/* vuetify-loader */
import installDirectives from "!../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Ripple from 'vuetify/lib/directives/ripple'
installDirectives(component, {Ripple})
